import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Page from '../../components/Page';
import { activitySearch } from '../../redux/modules/activityLog';
import { setCurrentPage } from '../../redux/modules/app';
import { resetCurrentRecordId, selectCurrentRecordId, setCurrentRecordId } from '../../redux/modules/insuredProfilePage';
import { itemSearch, itemsReset } from '../../redux/modules/items';
import { useCompanyActiveUsers } from '../../services/company-service';
import { useInsuredActiveRecordsData, useInsuredAllRecordsData, useInsuredArchivedRecordsData, useInsuredData, useInsuredOverallStatusData } from '../../services/insured-service';

import InsuredProfileHeader from './components/InsuredProfileHeader';
import RecordDetailsContainer from './components/RecordDetailsContainer';
import Records from './components/Records';
import { setCurrentRecordIdHelper } from './util';

const V2InsuredProfilePage = props => {
  const { companyId, insuredId, resourceId: recordId, resource } = useParams();
  const dispatch = useDispatch();
  const currentRecordId = useSelector(selectCurrentRecordId);

  useInsuredData(insuredId);
  useInsuredOverallStatusData(insuredId, { retry: false });
  useInsuredAllRecordsData({ insuredId, options: { retry: false } });
  useInsuredArchivedRecordsData({ insuredId, options: { retry: false } });
  useCompanyActiveUsers(companyId);
  const activeRecordsQuery = useInsuredActiveRecordsData({ insuredId });

  // set initial currentRecordId
  useEffect(() => {
    setCurrentRecordIdHelper({
      query: activeRecordsQuery,
      paramResource: resource,
      paramId: recordId,
      reduxId: currentRecordId,
      reduxAction: id => dispatch(setCurrentRecordId(id))
    });

    return () => {

    };
  }, [recordId, activeRecordsQuery]);

  useEffect(() => {
    dispatch(setCurrentPage('insured'));
    dispatch(itemsReset());
    dispatch(itemSearch.clearSearch());
    dispatch(activitySearch.clearSearch());

    return () => {
      dispatch(resetCurrentRecordId());
    };
  }, [companyId, insuredId]);

  return (
    <Page fixedHeight backgroundColor="grey">
      <InsuredProfileHeader insuredId={insuredId} />
      <Records insuredId={insuredId} recordId={currentRecordId} />
      <RecordDetailsContainer
        companyId={companyId}
        insuredId={insuredId}
        recordId={currentRecordId}
      />
    </Page>
  );
};

export default V2InsuredProfilePage;
